import { render, staticRenderFns } from "./goodVideo.vue?vue&type=template&id=7cf587b1&scoped=true&"
import script from "./goodVideo.vue?vue&type=script&lang=js&"
export * from "./goodVideo.vue?vue&type=script&lang=js&"
import style0 from "./goodVideo.vue?vue&type=style&index=0&id=7cf587b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf587b1",
  null
  
)

export default component.exports